import { UsageIntent } from '@/Enums/FirstPartyData/UsageIntent.enum';

export const BASE_TAB_ID = 'first-party-data-filter-tab';

export const USAGE_INTENT_OPTIONS = [UsageIntent.Attribution, UsageIntent.Retargeting];
